import { Injectable } from '@angular/core';
import { AppEnvironment } from '@env/app-environment';
import { environment } from '@env/environment';

@Injectable({ providedIn: 'root' })
export class AppConfigService<T extends AppEnvironment = AppEnvironment> {
  static appConfig: AppEnvironment;

  constructor() {}

  static loadConfig(): Promise<void> {
    let configUrl = '/assets/config/app.config.json';
    if (environment.production == false) {
      configUrl = '/assets/config/app.config.Dev.json';
    }

    return new Promise((resolve, reject) => {
      const oReq = new XMLHttpRequest();
      oReq.addEventListener('load', resp => {
        if (oReq.status === 200) {
          try {
            AppConfigService.appConfig = JSON.parse(oReq.responseText);
          } catch (e) {
            reject(e);
          }
          resolve();
        } else {
          reject(oReq.statusText);
        }
      });
      oReq.open('GET', `${window.location.origin}${configUrl}`);
      oReq.send();
    });
  }

  getConfig(): T {
    return AppConfigService.appConfig as T;
  }
}
